import React from 'react'
import style from './articles.style'

const RekomendaciiPoRazmetke = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>
        Рекомендации по разметке кампаний Google Ads для работы в ROMI center
      </h2>
      <p>
        Сервис ROMI center работает поверх сервиса веб аналитики Google
        Analytics. Google Analytics используется хранения данных о переходах,
        затратах, конверсиях и продажах.
      </p>
      <p>Детализация аналитики производится в разрезе utm меток.</p>
      <p>
        Для корректной работы ROMI center требуется правильная разметка
        utm-метками объявлений в рекламных кампаниях.
      </p>
      <p>ROMI center рекомендует формировать utm метки следующим образом:</p>
      <ul className={classes.articleList}>
        <li>utm_medium=cpc</li>
        <li>utm_source=google_ads</li>
        <li>
          {`utm_campaign=<название кампании>  или {campaignid} - идентификатор кампании в Google Ads`}
          <p>{`(здесь <название кампании> статичный текст латиницей)`}</p>
        </li>
        <li>
          {`utm_term={keyword}`}
          <p>
            {`(здесь {keyword} - динамический параметр, который подставляется автоматически Google Ads и определяет ключевое слово по которому осуществляется переход на сайт)`}
          </p>
        </li>
        <li>
          utm_content=(произвольная разметка, может содержать статический текст
          и динамические параметры)
        </li>
      </ul>
      <p>Пример разметки рекламных кампаний Google Ads:</p>
      <p>
        {`http://test.com/?utm_source=google_ads&utm_medium=cpc&utm_campaign=
        {campaignid}&utm_term={keyword}`}
      </p>
      <p>
        При разметке рекламных кампаний Google Ads вы можете также использовать
        динамические параметры Google Ads.
      </p>
      <p>
        Полный список поддерживаемых динамических параметров можно увидеть в{' '}
        <a
          href="https://support.google.com/google-ads/answer/6305348#urlinsertion"
          target="_blank"
          rel="noopener noreferrer"
        >
          справке Google Ads.
        </a>
      </p>
      <p>
        Обратите пожалуйста внимание, на особенность разметки кампаний в Google
        Ads для ROMI center.
      </p>
      <p>
        <strong>
          Обязательное требование для разметки кампаний - нужно заменить
          utm-метку Utm_source=google_ads
        </strong>
      </p>
      <p>
        Если в utm-метках объявлений Google Ads встретятся utm_source=google,
        данные затратам для таких объявлений будут переданы с
        utm_source=google_ads.
      </p>
      <p>
        Разметка Utm_source=google_ads требуется для того, чтобы было возможно
        загрузить расходы с НДС.
      </p>
      <p>
        ROMI center отправляет данные по затратам c привязкой к пяти utm-меткам:
      </p>
      <ul className={classes.articleList}>
        <li>utm_source</li>
        <li>utm_campaign</li>
        <li>utm_medium</li>
        <li>utm_keyword</li>
        <li>utm_content</li>
      </ul>
      <p>Три из них:</p>
      <ul className={classes.articleList}>
        <li>utm_source</li>
        <li>utm_campaign</li>
        <li>utm_medium</li>
      </ul>
      <p>- являются обязателными.</p>
    </article>
  )
}

export default style(RekomendaciiPoRazmetke)
